// 用户反馈弹窗：提交 → 后端转发 Telegram bot。复用 .modal 样式。
// 经 createPortal 渲染到 body：Nav 有 backdrop-filter 会创建 containing block，
// 直接在 Nav 内渲染会使 position:fixed 锚到 Nav 顶部小盒（弹窗卡顶、被刘海遮挡）。
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { api, ApiError } from '../api/client'

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  background: 'var(--bg-3, #1a1a23)',
  border: '1px solid var(--border, rgba(255,255,255,.08))',
  borderRadius: 8,
  color: 'var(--t, #e4e4e7)',
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
}

export default function FeedbackModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation()
  const [message, setMessage] = useState('')
  const [contact, setContact] = useState('')
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [error, setError] = useState('')

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const submit = async () => {
    const msg = message.trim()
    if (msg.length < 2) return
    setState('sending')
    setError('')
    try {
      await api.submitFeedback(msg, contact.trim())
      setState('sent')
      setTimeout(onClose, 1400)
    } catch (e: unknown) {
      setState('error')
      setError(e instanceof ApiError ? e.message : e instanceof Error ? e.message : t('feedback.fail'))
    }
  }

  const busy = state === 'sending'
  return createPortal(
    <div className="modal-overlay modal-overlay-center" onClick={onClose}>
      <div
        className="modal"
        style={{
          width: 'min(420px, calc(100% - 32px))',
          maxWidth: 'min(420px, calc(100% - 32px))',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{t('feedback.title')}</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose} aria-label="close">
            ✕
          </button>
        </div>
        <div className="modal-body">
          <p style={{ color: 'var(--t-2, #a1a1aa)', fontSize: 13, margin: '0 0 10px' }}>
            {t('feedback.hint')}
          </p>
          <textarea
            style={{ ...inputStyle, resize: 'vertical', marginBottom: 8 }}
            placeholder={t('feedback.placeholder')}
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            disabled={busy}
            autoFocus
          />
          <input
            style={inputStyle}
            placeholder={t('feedback.contactPh')}
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            disabled={busy}
          />
          {state === 'error' && <div className="error-box">{error}</div>}
          <button
            className="btn btn-primary btn-lg"
            style={{ width: '100%', marginTop: 10 }}
            disabled={busy || message.trim().length < 2}
            onClick={submit}
          >
            {busy ? `◐ ${t('feedback.sending')}` : state === 'sent' ? `✓ ${t('feedback.sent')}` : t('feedback.submit')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
